import styled from "react-emotion";
export interface SectionInterface {
  theme?: any;
}
export const Section = styled("section")(({ theme }: SectionInterface) => ({
  marginBottom: theme.spacing.unit * 5
}));
